import React from "react";

export default function StateOptions({ country }) {
    return (
        <>
            <option value="">- Select One - </option>
            {(!country || country === "USA") && (
                <>
                    <option value="AL">Alabama</option>
                    <option value="AK">Alaska</option>
                    <option value="AZ">Arizona</option>
                    <option value="AR">Arkansas</option>
                    <option value="CA">California</option>
                    <option value="CO">Colorado</option>
                    <option value="CT">Connecticut</option>
                    <option value="DE">Delaware</option>
                    <option value="DC">District Of Columbia</option>
                    <option value="FL">Florida</option>
                    <option value="GA">Georgia</option>
                    <option value="HI">Hawaii</option>
                    <option value="ID">Idaho</option>
                    <option value="IL">Illinois</option>
                    <option value="IN">Indiana</option>
                    <option value="IA">Iowa</option>
                    <option value="KS">Kansas</option>
                    <option value="KY">Kentucky</option>
                    <option value="LA">Louisiana</option>
                    <option value="ME">Maine</option>
                    <option value="MD">Maryland</option>
                    <option value="MA">Massachusetts</option>
                    <option value="MI">Michigan</option>
                    <option value="MN">Minnesota</option>
                    <option value="MS">Mississippi</option>
                    <option value="MO">Missouri</option>
                    <option value="MT">Montana</option>
                    <option value="NE">Nebraska</option>
                    <option value="NV">Nevada</option>
                    <option value="NH">New Hampshire</option>
                    <option value="NJ">New Jersey</option>
                    <option value="NM">New Mexico</option>
                    <option value="NY">New York</option>
                    <option value="NC">North Carolina</option>
                    <option value="ND">North Dakota</option>
                    <option value="OH">Ohio</option>
                    <option value="OK">Oklahoma</option>
                    <option value="OR">Oregon</option>
                    <option value="PA">Pennsylvania</option>
                    <option value="PR">Puerto Rico</option>
                    <option value="RI">Rhode Island</option>
                    <option value="SC">South Carolina</option>
                    <option value="SD">South Dakota</option>
                    <option value="TN">Tennessee</option>
                    <option value="TX">Texas</option>
                    <option value="UT">Utah</option>
                    <option value="VT">Vermont</option>
                    <option value="VA">Virginia</option>
                    <option value="WA">Washington</option>
                    <option value="WV">West Virginia</option>
                    <option value="WI">Wisconsin</option>
                    <option value="WY">Wyoming</option>
                </>
            )}
            {!country && <option value="">---</option>}
            {(!country || country === "Canada") && (
                <>
                    <option value="AB">Alberta</option>
                    <option value="BC">British Columbia</option>
                    <option value="MB">Manitoba</option>
                    <option value="NB">New Brunswick</option>
                    <option value="NL">Newfoundland and Labrador</option>
                    <option value="NS">Nova Scotia</option>
                    <option value="ON">Ontario</option>
                    <option value="PE">Prince Edward Island</option>
                    <option value="QC">Quebec</option>
                    <option value="SK">Saskatchewan</option>
                </>
            )}

            {!country && <option value="">---</option>}
            {(!country || country === "Mexico") && (
                <>
                    <option value="DIF">Distrito Federal</option>
                    <option value="AGS">Aguascalientes</option>
                    <option value="BCN">Baja California</option>
                    <option value="BCS">Baja California Sur</option>
                    <option value="CAM">Campeche</option>
                    <option value="CHP">Chiapas</option>
                    <option value="CHI">Chihuahua</option>
                    <option value="COA">Coahuila</option>
                    <option value="COL">Colima</option>
                    <option value="DUR">Durango</option>
                    <option value="GTO">Guanajuato</option>
                    <option value="GRO">Guerrero</option>
                    <option value="HGO">Hidalgo</option>
                    <option value="JAL">Jalisco</option>
                    <option value="MEX">M&eacute;xico</option>
                    <option value="MIC">Michoac&aacute;n</option>
                    <option value="MOR">Morelos</option>
                    <option value="NAY">Nayarit</option>
                    <option value="NLE">Nuevo Le&oacute;n</option>
                    <option value="OAX">Oaxaca</option>
                    <option value="PUE">Puebla</option>
                    <option value="QRO">Quer&eacute;taro</option>
                    <option value="ROO">Quintana Roo</option>
                    <option value="SLP">San Luis Potos&iacute;</option>
                    <option value="SIN">Sinaloa</option>
                    <option value="SON">Sonora</option>
                    <option value="TAB">Tabasco</option>
                    <option value="TAM">Tamaulipas</option>
                    <option value="TLX">Tlaxcala</option>
                    <option value="VER">Veracruz</option>
                    <option value="YUC">Yucat&aacute;n</option>
                    <option value="ZAC">Zacatecas</option>
                </>
            )}
            {(!country || country === "Australia") && (
                <>
                    <option value="NSW">New South Wales</option>
                    <option value="QLD">Queensland</option>
                    <option value="SA">South Australia</option>
                    <option value="TAS">Tasmania</option>
                    <option value="VIC">Victoria</option>
                    <option value="WA">Western Australia</option>
                </>
            )}

            {!country && <option value="">---</option>}
            {(!country || country === "Bahamas") && (
                <>
                    <option value="AK">Acklins</option>
                    <option value="BY">Berry Islands</option>
                    <option value="BI">Bimini</option>
                    <option value="BP">Black Point</option>
                    <option value="CI">Cat Island</option>
                    <option value="CO">Central Abaco</option>
                    <option value="CS">Central Andros</option>
                    <option value="CE">Central Eleuthera</option>
                    <option value="FP">City of Freeport</option>
                    <option value="CK">Crooked Island and Long Cay</option>
                    <option value="EG">East Grand Bahama</option>
                    <option value="EX">Exuma</option>
                    <option value="GC">Grand Cay</option>
                    <option value="HI">Harbour Island</option>
                    <option value="HT">Hope Town</option>
                    <option value="IN">Inagua</option>
                    <option value="LI">Long Island</option>
                    <option value="MC">Mangrove Cay</option>
                    <option value="MG">Mayaguana</option>
                    <option value="MI">Moore's Island</option>
                    <option value="NP">New Providence</option>
                    <option value="NO">North Abaco</option>
                    <option value="NS">North Andros</option>
                    <option value="NE">North Eleuthera</option>
                    <option value="RI">Ragged Island</option>
                    <option value="RC">Rum Cay</option>
                    <option value="SS">San Salvador</option>
                    <option value="SA">South Abaco</option>
                    <option value="SO">South Andros</option>
                    <option value="SE">South Eleuthera</option>
                    <option value="SW">Spanish Wells</option>
                    <option value="WG">West Grand Bahama</option>
                </>
            )}
        </>
    );
}
